import audi from './audi';
import westfield from './westfield';
import edmcake from './edmcake';
import freeland from './freeland';
import tally24 from './tally24';
import scrapAndHaul from './scrapAndHaul';
import upmo from './upmo';

export default {
  audi,
  westfield,
  edmcake,
  freeland,
  tally24,
  scrapAndHaul,
  upmo
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/index.js